import {
   Box,
   Flex,
   Stack,
   Avatar,
   Text,
   Divider,
   useColorModeValue,
   useColorMode,
   Image,
   Input,
   InputGroup,
   InputLeftElement,
   Skeleton,
   SkeletonCircle,
} from '@chakra-ui/react';
import {
   Drawer,
   DrawerBody,
   DrawerHeader,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   useDisclosure,
   IconButton,
} from '@chakra-ui/react';
import { Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react';
import Brand from 'components/sidebar/components/Brand';
import Links from 'components/sidebar/components/Links';
import React, { useCallback, useEffect } from 'react';
import { HiSwitchVertical } from 'react-icons/hi';
import { deleteCompany, getCompanies } from '../../../redux/actions/company';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TbDotsVertical } from 'react-icons/tb';
import { MdEdit } from 'react-icons/md';
import { FaRegEye } from 'react-icons/fa';
import { IoIosLogOut, IoMdSettings } from 'react-icons/io';
import { FaShareFromSquare } from 'react-icons/fa6';
import PlusIcon from 'assets/icons/PlusIcon';
import CompanyWithGst from '../../../views/admin/companyProfile/CompanyWithGst';
import CompanySettingForm from '../../../views/admin/companyProfile/CompanySettingForm';
import CompanyForm from '../../../views/admin/companyProfile/CompanyForm';
import SharedCompForm from '../../../views/admin/companyProfile/SharedCompForm';
import { Link, useNavigate } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import { useUser } from '../../../contexts/UserContext';
import { userProfile, updateUserHistory, ChangeCompany } from '../../../redux/actions/user';
import loaderAnimation from '../../../assets/img/auth/loding.gif';
import { SearchIcon } from '@chakra-ui/icons';
import { logout } from 'utils/auth';
import { useGlobal } from '../../../contexts';
import DeleteCompanyModal from './deleteConfoemation';

// Skeleton Loader Component for Company Selector
const CompanySelectorSkeleton = ({ isDark }) => {
   return (
      <div
         className={`
            relative overflow-hidden rounded-2xl p-3 h-[30px] py-7 mb-2
            ${isDark
               ? 'bg-gradient-to-br from-slate-800/90 via-slate-800/70 to-slate-800/90 border-2 border-slate-700/60'
               : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-50 border-2 border-blue-200/50'
            }
         `}>
         <Flex justifyContent="space-between" alignItems="center" className="w-full h-full">
            <Flex alignItems="center" gap={3} flex="1">
               <SkeletonCircle
                  size="40px"
                  startColor={isDark ? 'gray.600' : 'gray.200'}
                  endColor={isDark ? 'gray.700' : 'gray.300'}
               />
               <Box flex="1">
                  <Skeleton
                     height="16px"
                     width="70%"
                     startColor={isDark ? 'gray.600' : 'gray.200'}
                     endColor={isDark ? 'gray.700' : 'gray.300'}
                  />
               </Box>
            </Flex>
            <Skeleton
               height="24px"
               width="24px"
               borderRadius="md"
               startColor={isDark ? 'gray.600' : 'gray.200'}
               endColor={isDark ? 'gray.700' : 'gray.300'}
            />
         </Flex>
      </div>
   );
};

// Skeleton Loader Component for Company List Item
const CompanyItemSkeleton = ({ isDark }) => {
   return (
      <div
         className={`
            relative rounded-2xl p-2 py-2 mb-2
            ${isDark ? 'bg-slate-800/50 border-2 border-slate-700/60' : 'bg-white border-2 border-gray-200'}
         `}>
         <Flex justifyContent="space-between" alignItems="center">
            <Flex alignItems="center" gap={3} flex="1">
               <SkeletonCircle
                  size="40px"
                  startColor={isDark ? 'gray.600' : 'gray.200'}
                  endColor={isDark ? 'gray.700' : 'gray.300'}
               />
               <Skeleton
                  height="14px"
                  width="60%"
                  startColor={isDark ? 'gray.600' : 'gray.200'}
                  endColor={isDark ? 'gray.700' : 'gray.300'}
               />
            </Flex>
            <Skeleton
               height="24px"
               width="24px"
               borderRadius="md"
               startColor={isDark ? 'gray.600' : 'gray.200'}
               endColor={isDark ? 'gray.700' : 'gray.300'}
            />
         </Flex>
      </div>
   );
};

function SidebarContent(props) {
   const { routes } = props;
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   const { isOpen, onOpen, onClose } = useDisclosure();
   const { user } = useUser();
   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
   const [companyToDelete, setCompanyToDelete] = useState(null);
   const { companyList } = useGlobal();

   const companyId = user?.loginhistory?.companyId;
   const Admin = user?.isAdmin;
   const companyRight = Array.isArray(user?.userRights)
      ? user.userRights.find((right) => right.companyId === companyId)?.companyprofile
      : null;

   const [filteredCompanyList, setFilteredCompanyList] = useState(companyList);
   const { isOpen: isOpenCompanyModal, onOpen: onOpenCompanyModal, onClose: onCloseCompanyModal } = useDisclosure();
   const { isOpen: isOpenCompany, onOpen: onOpenCompany, onClose: onCloseCompany } = useDisclosure();
   const inputText = useColorModeValue('gray.700', 'gray.100');
   const {
      isOpen: isOpenCompanySetting,
      onOpen: onOpenCompanySetting,
      onClose: onCloseCompanySetting,
   } = useDisclosure();
   const {
      isOpen: isOpenShareCompanySetting,
      onOpen: onOpenShareCompanySetting,
      onClose: onCloseShareCompanySetting,
   } = useDisclosure();
   const btnRef = React.useRef();
   const [selectedSharedComp, setSelectedSharedComp] = useState(null);
   const [settingData, setSettingData] = useState(null);
   const [companyData, setCompanyData] = useState(null);
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
   const [showShortcuts, setShowShortcuts] = useState(false);
   const [selectedId, setSelectedId] = useState(null);
   const [isLoading, setIsLoading] = useState(false);
   const [isCompanyListLoading, setIsCompanyListLoading] = useState(true);
   const overlayBg = useColorModeValue('rgba(255, 255, 255, 0.8)', 'rgba(0, 0, 0, 0.8)');
   const [selectedCompanyId, setSelectedCompanyId] = useState(null);
   const [searchQuery, setSearchQuery] = React.useState('');
   const bg = useColorModeValue('#f2f7f2', 'navy.800');
   const [compShare, setCompShare] = useState(false);
   const [activeCompany, setActiveCompany] = useState(null);

   useEffect(() => {
      if (companyList && companyList.length > 0) {
         const storedCompanyId = localStorage.getItem('selectedCompanyId');
         const storedCompanyDBName = localStorage.getItem('dbName');
         const storedCompanyType = localStorage.getItem('selectedCompanyType');

         let foundCompany = null;

         if (storedCompanyId) {
            if (storedCompanyType === 'shared' && storedCompanyDBName) {
               foundCompany = companyList.find((c) => c.id === storedCompanyId && c.dbName === storedCompanyDBName);
            } else {
               foundCompany = companyList.find((c) => c.id === storedCompanyId);
            }
         }

         if (!foundCompany && user?.loginhistory?.companyId) {
            if (user?.loginhistory?.code && user?.loginhistory?.code !== '') {
               foundCompany = companyList.find(
                  (c) => c.id === user.loginhistory.companyId && c.dbName === user.loginhistory.code,
               );
            } else {
               foundCompany = companyList.find((c) => c.id === user.loginhistory.companyId);
            }
         }

         if (!foundCompany && companyList.length > 0) {
            foundCompany = companyList[0];
         }

         setActiveCompany(foundCompany);
      }
   }, [companyList, user]);

   useEffect(() => {
      if (user?.loginhistory?.companyId) {
         setSelectedCompanyId(user.loginhistory.companyId);
      } else if (localStorage.getItem('selectedCompanyId')) {
         setSelectedCompanyId(localStorage.getItem('selectedCompanyId'));
      } else if (companyList && companyList.length > 0) {
         setSelectedCompanyId(companyList[0].id);
         localStorage.setItem('selectedCompanyId', companyList[0].id);
      }
   }, [user, companyList]);

   useEffect(() => {
      setFilteredCompanyList(companyList);
      // Set loading to false when company list is available
      if (companyList && companyList.length >= 0) {
         setIsCompanyListLoading(false);
      }
   }, [companyList]);

   const handleSearchChange = (e) => {
      const value = e.target.value.toLowerCase();
      setSearchQuery(value);

      const filtered = companyList?.filter((company) => {
         const { name, gstRegNo, panNo } = company;

         return (
            (name && name.toLowerCase().includes(value)) ||
            (gstRegNo && gstRegNo.toLowerCase().includes(value)) ||
            (panNo && panNo.toLowerCase().includes(value))
         );
      });

      setFilteredCompanyList(filtered);
   };

   const getSelectedCompany = useCallback(() => {
      if (!companyList || companyList.length === 0) return null;

      const storedCompanyId = localStorage.getItem('selectedCompanyId');
      const storedCompanyDBName = localStorage.getItem('dbName');
      const storedCompanyType = localStorage.getItem('selectedCompanyType');

      let selectedCompany = null;

      if (storedCompanyId) {
         if (storedCompanyType === 'shared' && storedCompanyDBName) {
            selectedCompany = companyList.find(
               (c) =>
                  c.id === storedCompanyId &&
                  c.dbName === storedCompanyDBName &&
                  (c.isShared === true || c.shared === true),
            );
         } else {
            selectedCompany = companyList.find((c) => c.id === storedCompanyId && !c.isShared && !c.shared);
         }
      }

      if (!selectedCompany && user?.loginhistory?.companyId) {
         const loginHistoryCode = user?.loginhistory?.code;

         if (loginHistoryCode && loginHistoryCode !== '') {
            selectedCompany = companyList.find(
               (c) =>
                  c.id === user.loginhistory.companyId &&
                  c.dbName === loginHistoryCode &&
                  (c.isShared === true || c.shared === true),
            );
         } else {
            selectedCompany = companyList.find((c) => c.id === user.loginhistory.companyId && !c.isShared && !c.shared);
         }
      }

      if (!selectedCompany && companyList.length > 0) {
         const firstRegularCompany = companyList.find((c) => !c.isShared && !c.shared);
         selectedCompany = firstRegularCompany || companyList[0];
      }

      return selectedCompany;
   }, [companyList, user]);

   useEffect(() => {
      if (activeCompany) {
         if (activeCompany.isShared || activeCompany.shared) {
            localStorage.setItem('selectedCompanyType', 'shared');
         } else {
            localStorage.setItem('selectedCompanyType', 'regular');
         }
      }
   }, [activeCompany]);

   useEffect(() => {
      if (companyList && companyList.length > 0) {
         const selected = getSelectedCompany();
         setActiveCompany(selected);

         if (selected) {
            setSelectedCompanyId(selected.id);
         }
      }
   }, [companyList, user, getSelectedCompany]);

   const isCompanySelected = useCallback(
      (company) => {
         if (!company || !activeCompany) return false;

         if (activeCompany.isShared && company.isShared) {
            return company.id === activeCompany.id && company.dbName === activeCompany.dbName;
         } else if (activeCompany.isShared && !company.isShared) {
            return false;
         } else if (!activeCompany.isShared && company.isShared) {
            return false;
         } else {
            return company.id === activeCompany.id;
         }
      },
      [activeCompany],
   );

   const handleSwitchCompany = async (company) => {
      try {
         setActiveCompany(company);
         setSelectedCompanyId(company.id);

         if (currentCompany && currentCompany?.dbName && user?.loginhistory?.code === currentCompany?.dbName) {
            await dispatch(ChangeCompany());
            setCompShare(false);
         }

         await dispatch(updateUserHistory({ companyId: company.id, code: '' }));
         await dispatch(userProfile());
         navigate('/admin/default');
         onClose();
         setTimeout(() => window.location.reload(), 100);

      } catch (error) {
         console.error('Error switching company:', error);
         setIsLoading(false);
      }
   };

   const handleSharedSwitchCompany = async (company) => {
      try {
         setActiveCompany(company);
         setSelectedCompanyId(company.id);
         localStorage.setItem('selectedCompanyId', company.id);
         localStorage.setItem('dbName', company.dbName);

         const loginData = { code: company.dbName };

         await dispatch(ChangeCompany(loginData));
         await dispatch(updateUserHistory({ companyId: company.id, code: company.dbName }));
         setCompShare(true);
         await dispatch(userProfile());
         navigate('/admin/default');
         onClose();
         setTimeout(() => window.location.reload(), 100);

      } catch (error) {
         console.error('Error switching to shared company:', error);
         setIsLoading(false);
      }
   };

   const handleOpenCompany = () => {
      onClose();
      onOpenCompany();
   };

   const handleOpenCompanySetting = (id) => {
      const company = companyList?.find((company) => company.id.toString() === id.toString()) ?? null;
      setSettingData(company);
      onOpenCompanySetting();
   };

   const handleOpenShareCompanySetting = (id) => {
      const sharedComp = companyList?.find((company) => company.id.toString() === id.toString()) ?? null;
      setSettingData(sharedComp);
      onOpenShareCompanySetting();
   };

   const handleCloseShareCompanySetting = () => {
      // setSelectedSharedComp(null);
      onCloseShareCompanySetting();
   };

   const handleOpenCompanyModal = useCallback(
      (id) => {
         const company = companyList?.find((company) => company.id.toString() === id.toString()) ?? null;
         setCompanyData(company);
         onOpenCompanyModal();
      },
      [companyList, onOpenCompanyModal],
   );

   const handleOnDelete = useCallback(
      (id) => {
         const company = companyList?.find((company) => company.id.toString() === id.toString()) ?? null;
         setCompanyToDelete(company);
         setIsDeleteModalOpen(true);
         onClose();
      },
      [companyList, onClose],
   );

   const handleConfirmDelete = async () => {
      if (companyToDelete) {
         try {
            setIsLoading(true);

            // Delete the company
            await dispatch(deleteCompany(companyToDelete.id));

            // Get updated company list
            await dispatch(getCompanies());

            const remainingCompanies = companyList.filter((c) => c.id !== companyToDelete.id);

            if (remainingCompanies.length === 0) {
               // No companies left, redirect to create company
               navigate('/auth/create-comp', { replace: true });
            } else {
               // Select the first available company
               const newActiveCompany = remainingCompanies[0];

               if (newActiveCompany.isShared || newActiveCompany.shared) {
                  // Switch to shared company
                  const loginData = { code: newActiveCompany.dbName };
                  await dispatch(ChangeCompany(loginData));
                  await dispatch(
                     updateUserHistory({
                        companyId: newActiveCompany.id,
                        code: newActiveCompany.dbName,
                     }),
                  );
               } else {
                  // Switch to regular company
                  // If current company was shared, clear the shared company data
                  if (user?.code && user?.code !== '') {
                     await dispatch(ChangeCompany());
                  }
                  await dispatch(
                     updateUserHistory({
                        companyId: newActiveCompany.id,
                        code: '',
                     }),
                  );
               }

               // Update user profile to get fresh user data
               await dispatch(userProfile());

               // Force full page reload to refresh all data
               window.location.reload();
            }

            setIsDeleteModalOpen(false);
            setCompanyToDelete(null);
         } catch (error) {
            console.error('Error deleting company:', error);
            setIsLoading(false);
         }
      }
   };

   const handleOnShow = useCallback(
      (comp, type) => {
         localStorage.setItem('company-view-id', comp.id);
         localStorage.setItem('company-view-type', type === 'regular' ? 'regular' : comp?.dbName);
         navigate(`/admin/co-profile`, { replace: true });
         onClose();
      },
      [navigate, onClose],
   );

   const handleDelete = () => {
      dispatch(deleteCompany(selectedId));
      setDeleteDialogOpen(false);
      // 
   };

   // SidebarContent.jsx - replace the existing useEffect
   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (!isOpen && e.key === 'Alt') {
            e.preventDefault();
            setShowShortcuts((prev) => !prev);
            return;
         }

         if (!isOpen && showShortcuts) {
            if (e.key.toLowerCase() === 'x') {
               onOpen();
            }
            // ✅ Always hide shortcuts after ANY key press
            setShowShortcuts(false);
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
   }, [onOpen, showShortcuts, isOpen]);

   const currentCompany = companyList.find((c) =>
      user?.loginhistory?.code && user?.loginhistory?.code !== ''
         ? c.id === user?.loginhistory?.companyId && user?.loginhistory?.code === c?.dbName
         : c.id === user?.loginhistory?.companyId,
   );

   return (
      <>
         {isLoading && (
            <Flex
               position="fixed"
               top="0"
               left="0"
               right="0"
               bottom="0"
               zIndex="9999"
               justifyContent="center"
               alignItems="center"
               backgroundColor={overlayBg}
               backdropFilter="blur(5px)">
               <Image
                  src={loaderAnimation}
                  width={150}
                  height={150}
                  objectFit="cover"
                  style={{
                     position: 'absolute',
                     top: '50%',
                     left: '50%',
                     transform: 'translate(-50%, -50%)',
                  }}
               />
            </Flex>
         )}
         <Flex
            direction="column"
            height="100%"
            pt="10px"
            px="16px"
            borderRadius="30px"
            mr={{ sm: '1', md: '3', lg: '1' }}>
            <Brand />

            {/* Premium Company Selector with Skeleton */}
            {!activeCompany ? (
               <CompanySelectorSkeleton isDark={isDark} />
            ) : (
               <div
                  onClick={() => onOpen()}
                  className={`
                     relative overflow-hidden rounded-2xl p-3 h-[30px] py-7 mb-2 cursor-pointer
                     transition-all duration-300 group 
                     ${isDark
                        ? 'bg-gradient-to-br from-slate-800/90 via-slate-800/70 to-slate-800/90 border-2 border-slate-700/60 hover:border-emerald-500/40 hover:shadow-xl hover:shadow-emerald-500/10'
                        : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-50 border-2 border-blue-200/50 hover:border-blue-300 hover:shadow-xl hover:shadow-blue-200/50'
                     }
                  `}>
                  {/* Animated Background Gradient */}
                  <div
                     className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${isDark
                        ? 'bg-gradient-to-r from-emerald-500/5 via-teal-500/5 to-emerald-500/5'
                        : 'bg-gradient-to-r from-blue-100/30 via-indigo-100/30 to-blue-100/30'
                        }`}
                  />

                  <Flex justifyContent="space-between" alignItems="center" className="relative z-10 w-full h-full">
                     <Flex alignItems="center" gap={3} flex="1">
                        {/* Avatar with Glow */}
                        <div
                           className={`relative ${isDark ? 'shadow-lg shadow-emerald-500/20' : 'shadow-md shadow-blue-300/30'
                              } rounded-full`}>
                           {activeCompany?.logo || activeCompany?.liveUrl ? (
                              <img
                                 src={activeCompany.liveUrl || activeCompany.logo}
                                 crossOrigin="anonymous"
                                 alt="Logo"
                                 className="w-8 h-8 object-cover rounded-full ring-2 ring-offset-2 ring-emerald-400/30"
                              />
                           ) : (
                              <Avatar
                                 name={activeCompany?.name}
                                 src="https://bit.ly/broken-link"
                                 colorPalette="teal"
                                 size="sm"
                                 className="ring-2 ring-offset-2 ring-emerald-400/30"
                              />
                           )}
                           <div
                              className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 ${isDark ? 'bg-emerald-400 border-slate-800' : 'bg-green-500 border-white'
                                 } animate-pulse`}
                           />
                        </div>

                        {/* Company Name */}
                        <div className="flex-1">
                           <Text
                              fontSize="13px"
                              fontWeight="bold"
                              className={`transition-colors duration-200 ${isDark
                                 ? 'text-slate-100 group-hover:text-emerald-300'
                                 : 'text-gray-800 group-hover:text-blue-700'
                                 }`}
                              noOfLines={2}>
                              {activeCompany?.name}
                           </Text>
                        </div>

                        {/* Keyboard Shortcut */}
                        {showShortcuts && (
                           <span
                              className={`
         text-[12px] font-bold px-2 rounded-md border-2 backdrop-blur-sm
         transition-all duration-200
         ${isDark
                                    ? 'text-cyan-400 border-cyan-500/60 bg-cyan-500/15 shadow-[0_0_10px_rgba(34,211,238,0.3)]'
                                    : 'text-cyan-700 border-cyan-500/50 bg-cyan-50 shadow-sm'
                                 }
      `}>
                              X
                           </span>
                        )}
                     </Flex>

                     {/* Switch Icon with Animation */}
                     <div
                        className={`
                        p-2 rounded-xl transition-all duration-300
                        ${isDark
                              ? 'text-slate-400 group-hover:text-emerald-400 group-hover:bg-emerald-500/10 group-hover:rotate-180'
                              : 'text-gray-600 group-hover:text-blue-600 group-hover:bg-blue-100 group-hover:rotate-180'
                           }
                     `}>
                        <HiSwitchVertical size={20} />
                     </div>
                  </Flex>
               </div>
            )}

            {/* Navigation Links */}
            <Stack direction="column" mb="auto" mt="8px">
               <Box ps="0px" pe={{ md: '0px', '2xl': '1px' }}>
                  <Links
                     routes={routes}
                     onClose={onClose}
                     showShortcuts={showShortcuts}
                     setShowShortcuts={setShowShortcuts}
                  />
               </Box>
            </Stack>
            {/* Premium Logout Button */}
            <Box
               mx="auto"
               w="90%"
               position="sticky"
               bottom="0"
               zIndex={10}
               bg={`${isDark ? '#16213E' : 'white'}`}
               // borderTop="1px"
               borderColor={isDark ? 'whiteAlpha.100' : 'gray.200'}>
               <button
                  onClick={() => {
                     logout();
                     navigate('/auth/sign-in');
                     window.location.reload();
                  }}
                  className={`
         w-full flex items-center justify-center gap-3 py-1 px-4 rounded-2xl
         transition-all duration-300 group relative overflow-hidden
         mb-10
         ${isDark
                        ? 'bg-gradient-to-br from-red-500/20 via-rose-500/15 to-red-500/20 border-2 border-red-500/40 hover:border-red-400/60 hover:shadow-xl hover:shadow-red-500/20'
                        : 'bg-gradient-to-br from-red-50 via-rose-50 to-red-50 border-2 border-red-200/50 hover:border-red-300 hover:shadow-xl hover:shadow-red-200/50'
                     }
      `}>
                  {/* Animated Background */}
                  <div
                     className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${isDark
                        ? 'bg-gradient-to-r from-red-500/10 via-rose-500/10 to-red-500/10'
                        : 'bg-gradient-to-r from-red-100/40 via-rose-100/40 to-red-100/40'
                        }`}
                  />

                  <div
                     className={`
         p-2 rounded-xl transition-all duration-300 relative z-10
         ${isDark
                           ? 'text-red-400 bg-red-500/10 group-hover:bg-red-500/20'
                           : 'text-red-600 bg-red-100/60 group-hover:bg-red-200/60'
                        }
      `}>
                     <IoIosLogOut size={20} />
                  </div>
                  <Text
                     className={`
            font-semibold text-sm relative z-10 transition-colors duration-200
            ${isDark ? 'text-red-300 group-hover:text-red-200' : 'text-red-700 group-hover:text-red-800'}
         `}>
                     Logout
                  </Text>
               </button>
            </Box>
         </Flex>

         {/* Company Drawer */}
         <Drawer isOpen={isOpen} placement="left" onClose={onClose} finalFocusRef={btnRef}>
            <DrawerOverlay backdropFilter="blur(4px)" />
            <DrawerContent className={isDark ? 'bg-slate-900' : 'bg-white'}>
               <DrawerCloseButton className={isDark ? 'text-slate-300' : 'text-gray-700'} />
               <DrawerHeader className={isDark ? 'text-white' : 'text-gray-900'}>
                  <div className="flex items-center gap-2">
                     <div
                        className={`w-1 h-8 rounded-full ${isDark
                           ? 'bg-gradient-to-b from-emerald-400 to-teal-400'
                           : 'bg-gradient-to-b from-blue-500 to-indigo-500'
                           }`}
                     />
                     <span className="text-lg font-bold">Switch Company</span>
                  </div>
               </DrawerHeader>

               {/* Search Input */}
               <InputGroup w={{ base: '100%', md: '260px' }} style={{ marginLeft: 20, marginBottom: 10 }}>
                  <InputLeftElement>
                     <SearchIcon color="gray.400" w="auto" h="15px" />
                  </InputLeftElement>
                  <Input
                     cursor={'pointer'}
                     variant="search"
                     fontSize="sm"
                     bg={bg}
                     color={inputText}
                     fontWeight="500"
                     borderRadius={'30px'}
                     value={searchQuery}
                     onChange={handleSearchChange}
                     _placeholder={{ color: 'gray.400', fontSize: '14px' }}
                     placeholder="Search companies..."
                     className={`transition-all duration-200 ${isDark
                        ? 'focus:border-emerald-500/50 focus:shadow-lg focus:shadow-emerald-500/10'
                        : 'focus:border-blue-400 focus:shadow-lg focus:shadow-blue-200/50'
                        }`}
                  />
               </InputGroup>

               <div className={`h-px w-full ${isDark ? 'bg-slate-700' : 'bg-gray-200'}`} />

               <DrawerBody className="space-y-4">
                  {/* My Company Section */}
                  <div>
                     <div className="flex items-center justify-between mb-3">
                        <div
                           className="flex items-center gap-2"
                           onClick={() => {
                              // handleOpenCompany();
                              // onClose();
                           }}>
                           <div
                              className={`w-1 h-5 rounded-full ${isDark
                                 ? 'bg-gradient-to-b from-emerald-400 to-teal-400'
                                 : 'bg-gradient-to-b from-blue-500 to-indigo-500'
                                 }`}
                           />
                           <Text
                              fontWeight="bold"
                              fontSize="xs"
                              className={`uppercase tracking-wider ${isDark ? 'text-emerald-400' : 'text-blue-700'}`}>
                              My Company
                           </Text>
                        </div>
                        {user?.isAdmin && (
                           <IconButton
                              variant="ghost"
                              ref={btnRef}
                              size="sm"
                              onClick={() => {
                                 handleOpenCompany();
                                 onClose();
                              }}
                              icon={<PlusIcon />}
                              className={`
                        rounded-lg transition-all duration-200
                        ${isDark
                                    ? 'text-emerald-400 hover:bg-emerald-500/10 hover:text-emerald-300'
                                    : 'text-blue-600 hover:bg-blue-100 hover:text-blue-700'
                                 }
                     `}
                           />
                        )}
                     </div>

                     {/* Company List with Skeleton */}
                     <div className="space-y-2">
                        {isCompanyListLoading ? (
                           // Show skeleton loaders while loading
                           <>
                              <CompanyItemSkeleton isDark={isDark} />
                              <CompanyItemSkeleton isDark={isDark} />
                              <CompanyItemSkeleton isDark={isDark} />
                           </>
                        ) : (
                           filteredCompanyList
                              ?.filter((x) => !x.isShared)
                              ?.map((comp) => {
                                 const isSelected = isCompanySelected(comp);

                                 return (
                                    <div
                                       key={comp.id}
                                       className={`
                                 relative rounded-2xl p-2 py-2 mb-2 cursor-pointer
                                 transition-all duration-300 group 
                                 ${isSelected
                                             ? isDark
                                                ? 'bg-gradient-to-br from-emerald-500/15 via-teal-500/10 to-emerald-500/15 border-2 border-emerald-500/40 shadow-lg shadow-emerald-500/10'
                                                : 'bg-gradient-to-br from-blue-50 via-indigo-50 to-blue-50 border-2 border-blue-300/60 shadow-lg shadow-blue-200/40'
                                             : isDark
                                                ? 'bg-slate-800/50 border-2 border-transparent hover:border-slate-700/60 hover:bg-slate-800/80'
                                                : 'bg-white border-2 border-transparent hover:border-gray-200 hover:bg-gray-50'
                                          }
                              `}>
                                       {isSelected && (
                                          <div
                                             className={`absolute left-0 top-1/2 -translate-y-1/2 w-1 h-3/4 rounded-r-full ${isDark
                                                ? 'bg-gradient-to-b from-emerald-400 via-teal-400 to-emerald-400 shadow-lg shadow-emerald-500/30'
                                                : 'bg-gradient-to-b from-blue-500 via-indigo-500 to-blue-500'
                                                }`}
                                          />
                                       )}

                                       <Flex justifyContent="space-between" alignItems="center">
                                          <div
                                             onClick={() => {
                                                const lastCompanyType = localStorage.getItem('selectedCompanyType');
                                                handleSwitchCompany(comp, lastCompanyType);
                                                localStorage.setItem('selectedCompanyId', comp.id);
                                                localStorage.setItem('selectedCompanyType', 'regular');
                                                onClose();
                                             }}
                                             className="flex-1">
                                             <Flex alignItems="center" gap={3}>
                                                <div
                                                   className={`relative ${isSelected &&
                                                      (isDark
                                                         ? 'shadow-lg shadow-emerald-500/20'
                                                         : 'shadow-md shadow-blue-300/30')
                                                      } rounded-full w-8 h-8 overflow-hidden`}>
                                                   {comp?.logo ? (
                                                      <img
                                                         src={comp?.liveUrl}
                                                         crossOrigin="anonymous"
                                                         alt="Logo"
                                                         className="w-full h-full object-cover rounded-full"
                                                      />
                                                   ) : (
                                                      <Avatar
                                                         name={comp.name}
                                                         src="https://bit.ly/broken-link"
                                                         colorPalette="teal"
                                                         size="sm"
                                                      />
                                                   )}

                                                   {isSelected && (
                                                      <div
                                                         className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 ${isDark
                                                            ? 'bg-emerald-400 border-slate-800'
                                                            : 'bg-green-500 border-white'
                                                            } animate-pulse`}
                                                      />
                                                   )}
                                                </div>
                                                <Text
                                                   fontSize="sm"
                                                   fontWeight={isSelected ? '600' : '500'}
                                                   className={`transition-colors duration-200 ${isSelected
                                                      ? isDark
                                                         ? 'text-emerald-300'
                                                         : 'text-blue-700'
                                                      : isDark
                                                         ? 'text-slate-200'
                                                         : 'text-gray-700'
                                                      }`}>
                                                   {comp.name}
                                                </Text>
                                             </Flex>
                                          </div>
                                          <Menu>
                                             <MenuButton
                                                as={IconButton}
                                                aria-label="Options"
                                                icon={<TbDotsVertical />}
                                                variant="ghost"
                                                size="sm"
                                                className={`
                                          rounded-lg transition-all duration-200
                                          ${isDark
                                                      ? 'text-slate-400 hover:bg-slate-700 hover:text-slate-200'
                                                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
                                                   }
                                       `}
                                             />
                                             <MenuList>
                                                {(user?.isAdmin || companyRight?.edit) && (
                                                   <MenuItem
                                                      icon={<MdEdit />}
                                                      onClick={() => {
                                                         handleOpenCompanyModal(comp.id);
                                                         onClose();
                                                      }}>
                                                      Edit
                                                   </MenuItem>
                                                )}
                                                <Link to={`/admin/setting/co-profile`}>
                                                   <MenuItem
                                                      icon={<FaRegEye />}
                                                      onClick={() => {
                                                         handleOnShow(comp, 'regular');
                                                         onClose();
                                                      }}>
                                                      Show Details
                                                   </MenuItem>
                                                </Link>
                                                {user?.packageData?.[0]?.share_company && user?.isAdmin && (
                                                   <MenuItem
                                                      icon={<FaShareFromSquare />}
                                                      onClick={() => {
                                                         handleOpenShareCompanySetting(comp.id);
                                                         onClose();
                                                      }}>
                                                      Share Company
                                                   </MenuItem>
                                                )}
                                                {(user?.isAdmin || companyRight?.edit) && (
                                                   <MenuItem
                                                      icon={<IoMdSettings />}
                                                      onClick={() => {
                                                         handleOpenCompanySetting(comp.id);
                                                         onClose();
                                                      }}>
                                                      Setting
                                                   </MenuItem>
                                                )}
                                                {user?.isAdmin && (
                                                   <MenuItem
                                                      icon={<FaTrash />}
                                                      onClick={() => {
                                                         handleOnDelete(comp.id);
                                                         onClose();
                                                      }}>
                                                      Delete
                                                   </MenuItem>
                                                )}
                                             </MenuList>
                                          </Menu>
                                       </Flex>
                                    </div>
                                 );
                              })
                        )}
                     </div>
                  </div>

                  <Divider className={isDark ? 'border-slate-700' : 'border-gray-200'} />

                  {/* Shared Company Section */}
                  <div>
                     <div className="flex items-center justify-between mb-3">
                        <div
                           className="flex items-center gap-2"
                           onClick={() => {
                              // handleOpenCompany();
                              // onClose();
                           }}>
                           <div
                              className={`w-1 h-5 rounded-full ${isDark
                                 ? 'bg-gradient-to-b from-purple-400 to-pink-400'
                                 : 'bg-gradient-to-b from-purple-500 to-pink-500'
                                 }`}
                           />
                           <Text
                              fontWeight="bold"
                              fontSize="xs"
                              className={`uppercase tracking-wider ${isDark ? 'text-purple-400' : 'text-purple-700'}`}>
                              Shared Company
                           </Text>
                        </div>
                     </div>

                     {/* Shared Company List with Skeleton */}
                     <div className="space-y-2">
                        {isCompanyListLoading ? (
                           // Show skeleton loaders while loading
                           <>
                              <CompanyItemSkeleton isDark={isDark} />
                              <CompanyItemSkeleton isDark={isDark} />
                           </>
                        ) : (
                           companyList
                              ?.filter((x) => x.isShared)
                              ?.map((comp) => {
                                 const isSelected = isCompanySelected(comp);

                                 return (
                                    <div
                                       key={comp.id}
                                       className={`
                                 relative rounded-2xl p-3 cursor-pointer
                                 transition-all duration-300 group
                                 ${isSelected
                                             ? isDark
                                                ? 'bg-gradient-to-br from-purple-500/15 via-pink-500/10 to-purple-500/15 border-2 border-purple-500/40 shadow-lg shadow-purple-500/10'
                                                : 'bg-gradient-to-br from-purple-50 via-pink-50 to-purple-50 border-2 border-purple-300/60 shadow-lg shadow-purple-200/40'
                                             : isDark
                                                ? 'bg-slate-800/50 border-2 border-transparent hover:border-slate-700/60 hover:bg-slate-800/80'
                                                : 'bg-white border-2 border-transparent hover:border-gray-200 hover:bg-gray-50'
                                          }
                              `}>
                                       {isSelected && (
                                          <div
                                             className={`absolute left-0 top-1/2 -translate-y-1/2 w-1 h-3/4 rounded-r-full ${isDark
                                                ? 'bg-gradient-to-b from-purple-400 via-pink-400 to-purple-400 shadow-lg shadow-purple-500/30'
                                                : 'bg-gradient-to-b from-purple-500 via-pink-500 to-purple-500'
                                                }`}
                                          />
                                       )}

                                       <Flex justifyContent="space-between" alignItems="center">
                                          <div
                                             onClick={() => {
                                                handleSharedSwitchCompany(comp);
                                                localStorage.setItem('selectedCompanyId', comp.id);
                                                localStorage.setItem('selectedCompanyDBName', comp.dbName);
                                                localStorage.setItem('selectedCompanyType', 'shared');
                                                onClose();
                                             }}
                                             className="flex-1">
                                             <Flex alignItems="center" gap={3}>
                                                <div
                                                   className={`relative ${isSelected &&
                                                      (isDark
                                                         ? 'shadow-lg shadow-purple-500/20'
                                                         : 'shadow-md shadow-purple-300/30')
                                                      } rounded-full`}>
                                                   <Avatar
                                                      name={comp.name}
                                                      src="https://bit.ly/broken-link"
                                                      colorPalette="purple"
                                                      size="sm"
                                                   />
                                                   {isSelected && (
                                                      <div
                                                         className={`absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full border-2 ${isDark
                                                            ? 'bg-purple-400 border-slate-800'
                                                            : 'bg-purple-500 border-white'
                                                            } animate-pulse`}
                                                      />
                                                   )}
                                                </div>
                                                <Text
                                                   fontSize="sm"
                                                   fontWeight={isSelected ? '600' : '500'}
                                                   className={`transition-colors duration-200 ${isSelected
                                                      ? isDark
                                                         ? 'text-purple-300'
                                                         : 'text-purple-700'
                                                      : isDark
                                                         ? 'text-slate-200'
                                                         : 'text-gray-700'
                                                      }`}>
                                                   {comp.name}
                                                </Text>
                                             </Flex>
                                          </div>
                                          <Menu>
                                             <MenuButton
                                                as={IconButton}
                                                aria-label="Options"
                                                icon={<TbDotsVertical />}
                                                variant="ghost"
                                                size="sm"
                                                className={`
                                          rounded-lg transition-all duration-200
                                          ${isDark
                                                      ? 'text-slate-400 hover:bg-slate-700 hover:text-slate-200'
                                                      : 'text-gray-600 hover:bg-gray-100 hover:text-gray-800'
                                                   }
                                       `}
                                             />
                                             <MenuList>
                                                <Link to={`/admin/setting/co-profile`}>
                                                   <MenuItem
                                                      icon={<FaRegEye />}
                                                      onClick={() => {
                                                         handleOnShow(comp, 'shared');
                                                         onClose();
                                                      }}>
                                                      Show Details
                                                   </MenuItem>
                                                </Link>
                                             </MenuList>
                                          </Menu>
                                       </Flex>
                                    </div>
                                 );
                              })
                        )}
                     </div>
                  </div>
               </DrawerBody>
            </DrawerContent>
         </Drawer>

         {/* Modals */}
         <CompanyWithGst isOpen={isOpenCompany} onClose={onCloseCompany} />
         <CompanySettingForm
            isOpen={isOpenCompanySetting}
            onClose={onCloseCompanySetting}
            isEditMode={true}
            currentRow={settingData}
         />
         <SharedCompForm
            isOpen={isOpenShareCompanySetting}
            onClose={handleCloseShareCompanySetting}
            isEditMode={true}
            selectedSharedComp={settingData?.id}
            currentRow={selectedSharedComp}
         />
         <CompanyForm
            isOpen={isOpenCompanyModal}
            onClose={onCloseCompanyModal}
            isEditMode={true}
            currentRow={companyData && companyData?.id ? companyData : null}
         />

         <DeleteCompanyModal
            isOpen={isDeleteModalOpen}
            onClose={() => {
               setIsDeleteModalOpen(false);
               setCompanyToDelete(null);
            }}
            companyData={companyToDelete}
            onConfirmDelete={handleConfirmDelete}
            isDark={isDark}
         />
         {/* <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Company"
         /> */}
      </>
   );
}

export default SidebarContent;
